import { Component, OnInit, Renderer2 } from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import { NgbCollapse } from "@ng-bootstrap/ng-bootstrap";

@Component({
	selector: "app-offline-message",
	imports: [NgbCollapse, MatIcon],
	templateUrl: "./offline-message.component.html",
})
export class OfflineMessageComponent implements OnInit {
	isOnline = true;

	constructor(private _renderer: Renderer2) {}

	ngOnInit(): void {
		this._renderer.listen("window", "offline", () => {
			this.isOnline = false;
		});

		this._renderer.listen("window", "online", () => {
			this.isOnline = true;
		});
	}
}
